<template>
    <div class="help-title">
        <router-link :to="link" tag="div">
            <slot name="icon">
                <font-awesome-icon v-if="icon" :icon="icon" class="help-icon" />
            </slot>
            <span><slot /></span>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        link: String,
    },
};
</script>

<style lang="scss">
.help-title {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;

    > div {
        position: relative;
        width: 100%;
        padding-left: 20px;
        border-left: 3px solid transparent;

        &.router-link-active {
            border-left: 3px solid #6c3e91;
        }

        span {
            position: absolute;
            display: inline;
            left: 50px;
            font-size: 13px;
            line-height: 13px;
            font-weight: 600;
            text-transform: uppercase;

            color: #2a2a2a;
            // font-family: "Avenir Next";
            // font-size: 11px;
            // font-weight: bold;
            letter-spacing: 0.85px;
            line-height: 15px;
        }
    }

    &:hover span {
        color: #6c3e91;
    }

    .help-icon {
        color: #9ca5b0;
        font-size: 16px;
        line-height: 16px;
        width: 14px;
        height: 16px;
        padding-right: 14px;
    }

    .router-link-active {
        span {
            color: #6c3e91;
        }

        .help-icon {
            color: #6c3e91;
        }
    }
}
</style>
